import { Typography } from '@mui/material';

const SectionTitle = ({ title }) => {
  return <Typography variant="h2">{title}</Typography>;
};

export default SectionTitle;
